module.exports = __webpack_public_path__ + "static/media/navidad_logo.a9d9b850.png";